var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dark-mode-switch",class:{ __dark: _vm.isDarkMode }},[_c('base-icon-button',{on:{"click":_vm.toggleDarkMode}},[_vm._v(" "+_vm._s(_vm.isDarkMode ? "msr-moon_stars" : "msr-sunny-filled")+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }